import axios from '../utils/axios';

export default function updateSeekerEmailNotifSettings (adminId, data) {
    return axios.post(`/admin/${adminId}/seeker-notification-settings`, data);
}